import { reactFilter, TextLike } from 'mk/bazaar/common/filters/utils';
import { photoUrl } from 'mk/photo/photoUrl';
import Img from 'mk2/components/Img';
import { PhotoEntity } from 'mk2/schemas';
import * as React from 'react';

const IMAGE_MARK_RE = /\[image(\d+)\]/;

export const getInlinedImages = (text: string) => {
    const imageNos = [];
    const matcher = new RegExp(IMAGE_MARK_RE, 'g');

    while (true) {
        const match = matcher.exec(text);
        if (!match) {
            break;
        }
        imageNos.push(parseInt(match[1], 10) - 1);
    }
    return imageNos;
};

export const replaceImageMarks = (
    text: TextLike,
    photos: PhotoEntity[],
    className: string,
    photoVersionFun?: (PhotoEntity) => string,
) =>
    reactFilter(text, (s: string): React.ReactChild[] => {
    const ret = [];
    const matcher = new RegExp(IMAGE_MARK_RE, 'g');
    let from = 0;
    while (true) {
        const match = matcher.exec(s);
        if (match) {
            const matchLen = match[0].length;
            const to = matcher.lastIndex - matchLen;

            // copy text before this mark
            ret.push(s.substring(from, to));

            const photoIdx = parseInt(match[1], 10) - 1;
            const photo = photos[photoIdx];
            if (!photo) {
                continue;
            }

            ret.push(
                <Img
                    key={photo.id}
                    src={photoUrl(photo, photoVersionFun ? photoVersionFun(photo) : 's600x600')}
                    height={photo.height}
                    width={photo.width}
                    className={className}
                />);

            from = matcher.lastIndex;
        } else {
            ret.push(s.substring(from));
            break;
        }
    }
    return ret;
});

export const removeImageMarks = (text: TextLike) => reactFilter(text, (s: string): React.ReactChild[] => {
    const ret = [];
    const matcher = new RegExp(IMAGE_MARK_RE, 'g');
    let from = 0;
    while (true) {
        const match = matcher.exec(s);
        if (match) {
            const matchLen = match[0].length;
            const to = matcher.lastIndex - matchLen;

            // copy text before this mark
            ret.push(s.substring(from, to));

            // skipping, nothing to do

            from = matcher.lastIndex;
        } else {
            ret.push(s.substring(from));
            break;
        }
    }
    return ret;
});
